module.exports = __webpack_public_path__ + "static/img/science_technology_intensity_5.60f7e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/science_technology_intensity_5.png
// module id = 0XL/
// module chunks = 6